export default {"src":"/_next/static/media/basil_document-solid.88471521.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};